import { PropertyPmsResponse } from '../services/response/property-pms-response';
import { Organisation } from './organisation';

export class Property {
   id: number;
   propertyCode: string;
   timeZone: string;
   name: string;
   schemaName: string | null;
   hasCompletedOnBoarding: boolean;
   isPhobosEnabled: boolean;
   billingId: number | null;
   createdDate: string | null;
   isOnTrial: boolean | null;
   propertyPmsResponse: PropertyPmsResponse | undefined;
   organisations: Organisation[] = [];

   constructor() {
      this.id = 0;
      this.propertyCode = '';
      this.timeZone = '';
      this.name = '';
      this.schemaName = null;
      this.hasCompletedOnBoarding = false;
      this.propertyPmsResponse = undefined;
      this.isPhobosEnabled = false;
      this.billingId = null;
      this.createdDate = null;
      this.isOnTrial = null;
      this.propertyPmsResponse = undefined;
      this.organisations = [];
   }
}
